var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    class: ['img-comp', _vm.isInViewport ? 'img-comp--appear' : ''],
    attrs: {
      "src": _vm.heritedData.url,
      "alt": _vm.heritedData.title
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22c89efa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/ui/ImageComp.vue
// module id = NJC1
// module chunks = 1